import React, { useEffect } from 'react';
import { Link } from 'react-router';
import map from 'lodash/map';
import omit from 'lodash/omit';
import kebabCase from 'lodash/kebabCase';
import classnames from 'classnames';

import Footer from '../Footer';

import * as analytics from 'shared/lib/analytics';
import seo from 'shared/lib/seo';
import COLLECTIBLES_CATEGORIES from 'shared/lib/constants/collectiblesCategories';

import styles from './ProductsPage.module.css';

const ProductsPage = () => {
  useEffect(() => {
    seo.setProps({
      title: 'Sure Products',
      description: "Sure's suite of insurance products",
      url: 'https://www.sureapp.com/insurance-products',
    });
    analytics.page('Products');
  }, []);

  const personalTop = [
    {
      title: 'Collectible Insurance',
      to: '/collectible-insurance',
    },
  ];

  const personalBottom = [
    {
      title: 'Renters Insurance',
      to: '/renters-insurance',
    },
    {
      title: 'Home Warranty',
      to: '/home-warranty',
    },
  ];

  const business = [
    {
      title: 'Small Business Insurance',
      to: '/small-business-owners-insurance',
    },
  ];

  const travel = [
    {
      title: 'Baggage Protection',
      to: '/baggage-protection',
    },
    {
      title: 'Rental Car Insurance',
      to: '/rental-car-insurance',
    },
  ];

  const collectiblesLinks = () => {
    return map(
      omit(COLLECTIBLES_CATEGORIES, ['other', 'jewelry']),
      (config, key) => {
        return {
          title: `${config.title.replace(/([^s])s$/, '$1')} Insurance`,
          to: `/collectibles/${kebabCase(key)}-insurance`,
        };
      }
    );
  };

  return (
    <div className={styles.productsPage}>
      <div className={styles.header}>
        <h1 className={styles.headline}>Insurance</h1>
      </div>

      <div className={styles.container}>
        <h2 className={styles.title}>Personal</h2>
        <ul className={styles.list}>
          {map(personalTop, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
          <ul className={classnames([styles.list, styles.list_nested])}>
            {map(collectiblesLinks(), (link, i) => (
              <li
                className={classnames([
                  styles.list_item,
                  styles.list_item_nested,
                ])}
                key={i}
              >
                <Link
                  className={classnames([
                    styles.list_link,
                    styles.list_link_nested,
                  ])}
                  to={link.to}
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
          {map(personalBottom, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>

        <h2 className={styles.title}>Business</h2>
        <ul className={styles.list}>
          {map(business, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>

        <h2 className={styles.title}>Travel</h2>
        <ul className={styles.list}>
          {map(travel, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <Footer />
    </div>
  );
};

export default ProductsPage;
